<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/lembar_kerja/${this.detail.layanan_kode}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: true,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'No. Reg',
              width: '200px',
              value: 'lk_ajuan_no_reg',
              freeze: true,
              hide: false
            },
            {
              text: 'Kode Ajuan',
              width: '200px',
              value: 'lk_from_layanan_kode',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Kode Produk',
              width: '200px',
              value: 'lk_layanan_kode',
              freeze: false,
              hide: false
            },
            {
              text: 'Jalur Online / Offline',
              width: '200px',
              value: 'lk_ajuan_is_online',
              freeze: false,
              hide: false,
              format: 'on_off'
            },
            // {
            //   text: 'Pelapor',
            //   width: '200px',
            //   value: 'lk_ajuan_is_mandiri',
            //   freeze: false,
            //   hide: false,
            //   format: 'g_m'
            // },
            {
              text: 'Pelapor',
              width: '200px',
              value: 'lk_pelapor_role_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'lk_status',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal',
              width: '200px',
              value: 'lk_create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'lk_ajuan_no_reg',
              label: 'No. Reg',
              type: 'text',
              placeholder: 'Contoh. KK-20220812000004',
              value: '',
              width: '55%',
              required: false
            },
            {
              field: 'lk_status',
              label: 'Status',
              type: 'select',
              placeholder: 'Contoh. BELUM DIVERIFIKASI',
              value: '',
              option: ['BELUM DIVERIFIKASI', 'PROSES VERIFIKASI', 'DIKOREKSI', 'DISETUJUI TANPA NIK' , 'DISETUJUI TERBIT NIK', 'PROSES INPUT NIK'],
              width: '60%',
              required: false
            },
            {
              field: 'lk_create_datetime',
              label: 'Tanggal',
              type: 'date',
              placeholder: 'Contoh. 2021-12-13',
              value: '',
              picker: false,
              width: '40%',
              required: false
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: '',
              location: false
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: true,
              // api: '/worksheet/kia/'
              api: '/worksheet/'
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>